<template>
  <v-container
    fluid
    class="pt-2 grey lighten-2"
    :class="{ 'px-2': $vuetify.breakpoint.width <= 1600, 'px-0': $vuetify.breakpoint.width > 1600 }"
  >
    <v-layout wrap align-content-start>
      <v-flex xs8 xl9>
        <v-tabs v-model="summaryTab" v-if="showDetails">
          <v-tabs-slider color="accent"></v-tabs-slider>
          <v-tab><v-icon class="mr-1">fad fa-comments</v-icon> Comments</v-tab>
          <v-tab><v-icon class="mr-1">fad fa-file</v-icon> Documents</v-tab>
        </v-tabs>
        <v-tabs-items v-model="summaryTab">
          <v-tab-item>
            <v-card class="customer-summary-list" light flat>
              <v-progress-circular
                size="20"
                :width="3"
                color="accent"
                indeterminate
                class="ml-2"
                v-if="LoadingComments"
              ></v-progress-circular>
              <comment-list :customer="customer"></comment-list>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card class="customer-summary-list" light flat>
              <document-list
                :documents="customer.documents"
                :customer="customer"
                :referral="null"
                v-if="
                  UserHasRole('Platform') ||
                    UserHasRole('Call Centre') ||
                    UserHasRole('Property Broker') ||
                    (showDetails && UserHasRole('Provider'))
                "
              ></document-list>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
      <v-flex xs4 xl3>
        <v-card class="customer-summary-container mb-2 ml-1" flat>
          <enquiry-actions
            v-if="UserHasRole('Provider') && !UserHasRole('Property Broker')"
            :customer="customer"
            class="ma-2"
          ></enquiry-actions>
          <v-subheader class="title">
            Business Details
          </v-subheader>
          <v-card flat class="pa-2">
            <customer-info :customer="customer" :key="customer.id"></customer-info>
          </v-card>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import EnquiryActions from '../EnquiryActions/EnquiryActions';
import DocumentList from '../Documents/DocumentList';
import CommentList from '../Comments/CommentList';
import CustomerInfo from './CustomerInfo';

export default {
  components: {
    DocumentList,
    EnquiryActions,
    CommentList,
    CustomerInfo
  },
  name: 'customer-summary',
  props: ['customer'],
  data: () => ({
    summaryTab: 0
  }),
  methods: {},
  computed: {
    ...mapGetters(['UserHasRole', 'PlatformUser', 'LoadingComments', 'FunderEnquiries']),
    showDetails() {
      if (this.UserHasRole('Platform') || this.UserHasRole('Call Centre') || this.UserHasRole('Property Broker')) {
        return true;
      }
      let enquiry = _.find(this.FunderEnquiries.Active, ['customer.id', this.customer.id]);
      return !_.isUndefined(enquiry) && enquiry.customer.name.provider !== 'Content Hidden';
    }
  }
};
</script>

<style lang="scss" scoped>
.customer-summary-container {
  height: calc(100vh - 237px);
  max-height: calc(100vh - 237px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.customer-summary-list {
  height: calc(100vh - 285px);
  max-height: calc(100vh - 285px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
